export default __webpack_public_path__ + "static/media/orientation_guideline.aa1a2513.pdf";